export default "__VITE_ASSET__BGzsyCrd__"